import { useState } from 'react'

import { ViewProperties } from './ViewProperties'
import { NewProperty } from './NewProperty'
import { EditPropertyContainer } from './EditPropertyContainer'
import { Property } from 'api/clients/PropertyClient'

const ALL_EDIT_COMPONENTS = [
  'EditFolderProperty',
  'EditDefaultProperty',
  'EditWorkspaceProperty',
  'EditWorkflowProperty',
] as const
export type EditPropertyPadOptions = (typeof ALL_EDIT_COMPONENTS)[number]

export type VisiblePadOptions = EditPropertyPadOptions | 'ViewProperties' | 'NewProperty'

export enum PropertyVisibility {
  Shown = 'shown',
  Hidden = 'hidden',
}

export type EditableProperty = {
  property: Property
  visibility: PropertyVisibility
}

type FinderProps = {
  property: Property
  workflowProperty: Property | null | undefined
}

export const findEditComponent = ({ property, workflowProperty }: FinderProps): EditPropertyPadOptions => {
  if (property.default_type || property.property_tag) return 'EditDefaultProperty'
  if (property.id === workflowProperty?.id) return 'EditWorkflowProperty'
  if (!property.scope_project_id) return 'EditWorkspaceProperty'
  return 'EditFolderProperty'
}

type Props = {
  close: () => void
  onBackButtonPress?: () => void
}

export const Properties = ({ close, onBackButtonPress }: Props) => {
  const [visiblePad, setVisiblePad] = useState<VisiblePadOptions>('ViewProperties')
  const [editableProperty, setEditableProperty] = useState<EditableProperty | undefined>()

  return (
    <div data-testid="view-modifier-properties">
      {visiblePad === 'ViewProperties' && (
        <ViewProperties
          onBackButtonPress={onBackButtonPress}
          setVisiblePad={setVisiblePad}
          setEditableProperty={setEditableProperty}
        />
      )}
      {visiblePad === 'NewProperty' && (
        <NewProperty onBackButton={() => setVisiblePad('ViewProperties')} onClose={close} />
      )}
      {ALL_EDIT_COMPONENTS.includes(visiblePad as EditPropertyPadOptions) && editableProperty && (
        <EditPropertyContainer
          visiblePad={visiblePad as EditPropertyPadOptions}
          editableProperty={editableProperty}
          onBackButton={() => setVisiblePad('ViewProperties')}
          onClose={close}
        />
      )}
    </div>
  )
}

export default Properties
